
import Vue from 'vue'
import XTable from 'vux/src/components/x-table/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

var BuyApplyPage = Vue.extend({})
Vue.component('buyApply-page', BuyApplyPage)

export default {
name: 'BuyApplyPage',
components: {
XTable,XInput,XButton
},
props: {
saveStatus: Number
},
data () {
return {
baseUrl: this.$store.state.url,
flowId: '',
info: {},


refRecordId: '',
refModule: '',
fileObj: {},//文件上传集合
fileShowList: [], // 上传附件集合-预览
uploadedFileIdList: [], // 已上传附件ID集合
rootPathConfig: '',
fileChange: false,


name: '',
remark: '',
remark2: '',
buyReason: '',

}
},
mounted () {
this.$emit('sendTitleToParent','资产购买申请');
this.axios({
url: this.baseUrl+'/wechat/assetBuy/modAssetBuy?businessType=1',
method: 'get'
}).then((response) => {
this.info = response.data.obj;
this.refRecordId = response.data.refRecordId;
this.refModule = response.data.refModule;
this.rootPathConfig = response.data.rootPathConfig;
}).catch((response) => {
this.$vux.loading.hide();
});
},
methods: {
showMsg (msg) {
this.$vux.alert.show({
title: msg
})
setTimeout(() => {
this.$vux.alert.hide()
}, 2000)
},
chooseFile () { // 选择附件

this.deleteFile(0);

this.fileObj = document.getElementById('file').files;

let that = this;
let file = this.fileObj[0];
let reader = new FileReader();
reader.readAsDataURL(file);
reader.onload = function (e) {
that.fileShowList.push(this.result)
}
this.fileChange = true;
},
deleteFile (index) { // 删除已选附件
this.fileShowList.splice(index, 1);
let deleteFileId = this.uploadedFileIdList[index];
let fileData = new FormData();
fileData.append('fileId', deleteFileId);
this.fileChange = false;
},
saveForm () {//保存
if(this.name == ''){
this.showMsg('请补充必填信息');
return false;
}
this.$vux.loading.show({
text: '加载中'
});

let formData = new FormData();
formData.append("id",this.info.id);
formData.append("name",this.name);
formData.append("remark",this.remark);
formData.append("remark2",this.remark2);
formData.append("buyReason",this.buyReason);
formData.append("businessType",'1');
if(this.fileObj[0] && this.fileChange == true){
formData.append('file', this.fileObj[0]);
this.fileChange = false;
}else{
formData.append('file', '');
}

this.axios({
url: this.baseUrl+'/wechat/assetBuy/saveForm',
method: 'post',
headers: {
'Accept': 'application/json',
'Content-Type': 'application/x-www-form-urlencoded'
},
data: formData,
}).then((response) => {
console.log('购买资产saveForm',response.data,this.saveStatus);
if(response.data.status == 0){//保存失败
this.$vux.loading.hide();
this.showMsg(response.data.msg);
}else if(this.saveStatus == 0&&response.data.status == 1){//父组件操作发起，并且保存成功
this.startFlow();
}else if(this.saveStatus == 1&&response.data.status == 1){//父组件操作提交，并且保存成功
this.$emit('sendStatusToParent',{status:1});
this.$vux.loading.hide();
}
}).catch((response) => {
this.$vux.loading.hide();
});
},
startFlow () {//发起
let startData = new FormData();
startData.append("id",this.info.id);
startData.append("flowId",this.info.flowId);
this.axios({
url: this.baseUrl+'/wechat/assetBuy/startFlow',
method: 'post',
headers: {
'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
},
data: startData
}).then((response) => {
console.log('购买资产startFlow',response.data);
this.showMsg('保存成功！请继续完成提交操作！');

if(response.data.status == 1){

this.$emit('sendStatusToParent',{
status:0,
id:response.data.taskId,
stepId:response.data.stepId
});
}
this.$vux.loading.hide();
}).catch((response) => {
this.$vux.loading.hide();
});

}
}
}



// WEBPACK FOOTER //
// ./src/components/launch/attendance/buyApply.vue